import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ISizeName } from '@df/core/service/client';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NICmsBlock } from '@icms/core/resource/block/icms-block';
import { NeedLoginServiceDecorator } from '../../../customer/util/need-login.service.decorator';

export namespace NProductVipContentModal {
    export const BLOCK_ID = 'vip-content-modal';
    export interface IBlockData extends NICmsBlock.IData<IBlockDataContent> {}
    export interface IBlockDataContent {
        title: string;
        subtitle: string;
    }
}

@DfCmsModal({
    id: NProductVipContentModal.BLOCK_ID,
    name: 'Vip Content',
    position: (sizeId: ISizeName) => (sizeId === 'S' ? 'bottom' : undefined),
    config: (sizeId: ISizeName) => ({
        closeOnNavigation: true,
        maxWidth: sizeId === 'S' || sizeId === 'M' ? '91vw' : '455px',
        width: sizeId === 'S' || sizeId === 'M' ? '343px' : '455px',
        height: sizeId === 'S' || sizeId === 'M' ? '295px' : '466px',
        disableClose: true
    }),
    blockGroup: 'modals',
    priority: 20,
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: sizeName => ({ S: ['S', 'M'], M: ['S', 'M'], L: ['L', 'X'], X: ['L', 'X'] })[sizeName]
})
@ICmsComponent<VipContentComponent>({
    id: NProductVipContentModal.BLOCK_ID,
    block: {
        url: NProductVipContentModal.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Vip Content Popup',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true,
            default: "Don't miss out on this!"
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'subtitle',
            title: 'Subtitle',
            required: true,
            default: 'You need to be a VIP to access this content. Please register below.'
        }
    ]
})
@Component({
    selector: 'vip-content-modal',
    templateUrl: './vip-content-modal.html',
    standalone: true,
    imports: [ICmsClientModule, TranslationModule, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VipContentComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content!: NProductVipContentModal.IBlockDataContent;

    constructor(
        private modalRef: ModalRef<any>,
        private needLoginService: NeedLoginServiceDecorator,
        private router: Router
    ) {
        super();
    }

    protected close(): void {
        this.modalRef.close();
    }

    protected login(): void {
        const path = this.router.url;
        this.needLoginService.needLogin(() => {
            if (path !== this.router.url) {
                this.router.navigateByUrl(path);
            }
        }, 'vipModal');
    }
}
